import { render, staticRenderFns } from "./_basic.vue?vue&type=template&id=e3789800&scoped=true"
import script from "./_basic.vue?vue&type=script&lang=js"
export * from "./_basic.vue?vue&type=script&lang=js"
import style0 from "./_basic.vue?vue&type=style&index=0&id=e3789800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3789800",
  null
  
)

export default component.exports